import { SearchHistory } from "./components/SearchHistory";
import { SearchFilters } from "./components/SearchFilters";
import { Spinner } from "@/view/components/ui/spinner";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/view/components/ui/sheet";
import TransactionDetails from "../Dashboard/components/TransactionTable/components/TransactionDetails";
import { TransactionSupport } from "../Dashboard/components/TransactionTable/components/TransactionDetails/components/TransactionSupport";
import { UploadFiles } from "../Dashboard/components/TransactionTable/components/TransactionDetails/components/UploadFiles";
import { useSupportController } from "./useSupportController";
import { TableSupport } from "./components/TableSupport";
import { TableDocuments } from "./components/TableDocuments";
import { ArrowLeft } from "lucide-react";
import { useEffect, useState } from "react";

export const Support = () => {
  const {
    data,
    handleMakeFetchAgain,
    handleRowClick,
    handleDocumentRowClick,
    handleSearch,
    handleSheetState,
    isFetching,
    isLoading,
    selectedId,
    preparedData,
    documentsTransactions,
    searchQuery,
    selectedFilters,
    setSelectedFilters,
    setSheetOpen,
    sheetOpen,
    productsCatalog,
  } = useSupportController();

  const [step, setStep] = useState(0);

  const title: Record<number, string> = {
    0: "Detalhes da transação",
    1: "Solicitar informações",
    2: "Documentos",
  };

  useEffect(() => {
    if (sheetOpen) {
      setStep(0);
    }
  }, [sheetOpen]);

  return (
    <div>
      <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
        <SheetContent className="w-[340px] overflow-y-auto rounded-2xl bg-[#F4F5F7] p-2 xs:mr-5 xs:mt-5 xs:h-[95%] xs:w-96 xs:p-5">
          <div className="min-h-[800px]">
            <SheetHeader>
              <SheetTitle className="text-xl font-semibold">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    {step > 0 && (
                      <ArrowLeft
                        size={20}
                        onClick={() => setStep(0)}
                        className="cursor-pointer"
                      />
                    )}
                    <h2>{title[step]}</h2>
                  </div>
                </div>
                <div className="my-5 w-full border-b-[1px] border-gray01" />
              </SheetTitle>
            </SheetHeader>
            {selectedId && step === 0 && (
              <TransactionDetails
                onSupport={() => setStep(1)}
                onDocuments={() => setStep(2)}
              />
            )}
            {selectedId && step === 1 && <TransactionSupport />}
            {selectedId && step === 2 && (
              <UploadFiles onBack={() => setStep(0)} />
            )}
          </div>
        </SheetContent>
      </Sheet>
      <div className="space-y-8 pb-10">
        <SearchFilters
          selectedFilters={selectedFilters}
          onFilterChange={setSelectedFilters}
          searchValue={searchQuery}
          onSearchChange={handleSearch}
        />
        {isFetching || isLoading ? (
          <div className="flex h-screen items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
            <TableDocuments
              data={documentsTransactions}
              productsCatalog={productsCatalog}
              handleRowClick={handleDocumentRowClick}
            />
            <div>
              {searchQuery === "" && data ? (
                <SearchHistory
                  handleMakeFetchAgain={handleMakeFetchAgain}
                  supports={data.supports}
                />
              ) : (
                preparedData && (
                  <TableSupport
                    data={preparedData}
                    handleRowClick={handleRowClick}
                    handleSheetState={handleSheetState}
                  />
                )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
